export default __webpack_public_path__ + "static/media/download.a2d44ab6.svg";